import React, { HTMLAttributes } from 'react';
import { cx } from '@emotion/css';

interface DataListProps extends HTMLAttributes<HTMLDListElement> {
  data: Array<{ title: string; data?: string; className?: string }>;
  config?: {
    titleClassName?: string;
    dataClassName?: string;
  };
}

export const DataList = ({ data, config, ...props }: DataListProps) => {
  const { titleClassName, dataClassName } = config ?? {};
  return (
    <dl {...props}>
      {data.map(
        ({ title, data, className }, i) =>
          data && (
            <React.Fragment key={i}>
              <dt
                className={cx(
                  'stihl-text-body-default-bold p-3 py-1 tablet:rounded-l-md rounded-t-md tablet:rounded-tr-none',
                  titleClassName,
                  className
                )}
              >
                {title}
              </dt>
              <dd
                className={cx(
                  'stihl-text-body-default-reg p-3 py-1 tablet:rounded-r-md rounded-b-md tablet:rounded-bl-none',
                  dataClassName,
                  className
                )}
              >
                {data}
              </dd>
            </React.Fragment>
          )
      )}
    </dl>
  );
};
